/**
 * Index Page 模块常量定义
 */

import { Env } from "@/config/env";

// Tab 类型
export enum TabEnum {
  Course,
  Tutorial,
}

// 导航栏下拉选项 Key
export enum HomeTabKey {
  Courses = "courses",
  Tutorials = "tutorials",
}

// Swiper 配置
export const SWIPER_CONFIG = {
  DIRECTION: "vertical",
  SLIDES_PER_VIEW: 1,
  INITIAL_SLIDE_OFFSET: 5, // 首次渲染且列表长度为10时的初始索引
} as const;

// 本地存储键
export const STORAGE_KEYS = {
  UNFINISHED_COURSEWARE: "UNFINISHED_COURSEWARE_INFO",
} as const;

// API 端点
export const API_ENDPOINTS = {
  REPORT: (coursewareId: string) =>
    `${Env.API_URL}/api/coursewares/${coursewareId}/report`,
} as const;
